import React from "react";
import FormViewer from "../../components/FormViewer";
import LoaderButton from "../../components/LoaderButton";
import Modal from '../../components/Modal'
import HttpServices from "../../utils/Http.services";
import { checkPermission, checkTranslation, getObject, translate } from "../../utils/useful";
// import { countriesCode } from '../variables/countries'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import tableComponents from '../../components/tableComponents'
import ItemModal from "../../modals/ItemModal";
import Collapsible from "react-collapsible";
import i18n from "../../i18n";
import store from "../../stores/storeConfig";
import Loader from 'react-loader-spinner'
import moment from 'jalali-moment'

class AdminSectionFormApplet extends React.Component {

    openEditModal = (info) => {
        if (this.editModal.modal.showModal) {
            console.log('openEditModalopenEditModal')
            console.log(info)
            this.setState({ plannedList: info })
            this.editModal.modal.showModal()
        }
    }
    state = {
        countries: [],
        closedGroups: {},
        collapses: {},
        docPermission: [],
        sections: [],
        headers: this.props.page?.headers,
        headerObject: this.props.page?.headerObject,
        actions: this.props.page?.actions,
        reports: this.props.page?.reports,
        planningList: this.props.page?.planningList,
        submitedResult: this.props.page?.submitedResult,
        recordResultHeader: this.props.page?.recordResultHeader,
        effectivenessSection: this.props.page?.effectivenessSection,
        result: this.props.page?.result,
        effectivenessData: {},
        similar: [],
        similarData: [],
        submitData: {},
        isLoader: true,
        currentTab: 'document',
        tabs: [
            { title: "{{lang}}Document", key: 'document' },
            { title: "{{lang}}History", key: 'history' },
            { title: "{{lang}}correction", key: 'correction' },
        ],
        tableActions: {
            edit: { key: "submit", label: "Edit", bgColor: 'red', color: '#fff', function: this.openEditModal, loader: "isPostingData" },
            // review: { key: "review", label: "بازبینی", bgColor: '#F87C56', color: "#fff", function: "" },
            // cancel: { key: "cancel", label: "رد", bgColor: '#F87C56b7f', color: '#fff', function: "" },
        },
        reportActions: {

            edit: { key: "edit", label: 'ویرایش', color: 'rgb(27, 109, 216)', function: this.openEditModal, permission: ['view'] },
            // remove: { key: "remove", label: 'حذف', color: '#e96363', function: this.openRemoveModal, permission: ['delete'] }
        },
        correction: [
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Request title', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'documentGroup', type: 'SelectInput', information: { label: '{{lang}}Document group', updateAfterSelect: true, isSearchable: false, address: 'getDocumentGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select', required: false }, showMain: false },
            { col: '6', key: 'documentType', type: 'SelectInput', information: { label: '{{lang}}Type of documents', updateAfterSelect: true, isSearchable: false, address: 'getDocumentType', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select', required: false }, showMain: false },
            { col: '6', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'code', type: 'TextInput', information: { label: '{{lang}}Code', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
            { col: '6', key: 'documentStatus', type: 'TextInput', information: { label: '{{lang}}Status', disabled: true, required: false, }, showMain: true, inExport: true },
            { col: '12', key: 'files', type: 'FileInput', information: { label: '{{lang}}Files', single: false, placeholder: '{{lang}}Attachments', required: false }, showMain: false },

        ],
        history: [
            // { title: "توضیحات ", des: "روش اجرایی باز و بست نمودن فلکسیبل دمش از کف پاتیلروش اجرایی باز و بست نمودن فلکسیبل دمش از کف پاتیلروش اجرایی باز و بست نمودن فلکسیبل دمش از کف پاتیلروش اجرایی باز و بست نم", date: "2201/50/85" },
            // { title: "توضیحات ", des: "بل دمش از کف پ", date: "2201/50/85" },
            // { title: "توضیحات ", des: "کف پاتیلروش اجرایی باز و", date: "2201/50/85" },
            // { title: "توضیحات ", des: "کف پاتیلروش اجرایی باز و", date: "2201/50/85" },
        ]
    }

    componentDidMount() {
        this.setState({ isLoader: true, sections: this.props.page?.sections, headers: this.props.page?.headers, similar: this.props.page?.similar }, () => {
            console.log('this.props.page?.headerss', this.props.page?.headers)
            console.log('this.props.page?.headerss', this.state.headers)
            this.init()
        })
        // if (this.state.similar) {
        //     this.similar()
        // }
        // console.log('info page', this.props.page.actions)
        // console.log('this.props.page.sections', this.props.page.sections)
        // console.log('window.location', window.location)

        // console.log('admin', this.props.page.headers)
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log('befdw', prevState.headers)
        // console.log('updatedw', this.state.headers)
        console.log('this.props.pagesssdd', this.props.page)
        if (this.props.page && this.props.page.headers && prevProps.page?.headers != this.props.page.headers && this.props.page.pageType == 'AdminSectionFormApplet') {
            this.init()
            // this.setState({ headers: this.props.page?.headers })

        }
    }


    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }

    init = () => {
        let page = this.props.page
        let address = page.fetchUrl
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let id = params.get('id');
        console.log('id is', id)
        let body = {}
        body.id = id

        console.log('address', address)
        console.log('page.postBody', page.postBody)
        if (page.postBody) {
            body = { ...body, ...page.postBody }
        }
        HttpServices.request(address, body, (fetchResult, fetchError) => {
            console.log('checkfetchResult', address, fetchResult)
            this.setState({ isLoader: false })
            if (fetchError) {
                return
            }
            if (fetchResult?.info) {

                let data = fetchResult.info

                this.checkSections(fetchResult?.sections)
                // console.log('fetchall3', fetchResult.docPermission)
                this.setState({ data, id: id, docPermission: fetchResult.docPermission, level: fetchResult?.level, stepLevel: fetchResult?.stepLevel, history: fetchResult?.histories ?? [] }, () => {
                    // console.log('herrrrrrrrrrrrrrrrrrre', this.props.page.headerObject)
                    let headers = []
                    let actions = this.state.actions
                    console.log('this.sdqwdqwdqwon', this.state.docPermission)
                    if (Array.isArray(this.state.docPermission)) {

                        this.state.docPermission.forEach(element => {
                            if (this.props.page?.conditionalActions && this.props.page?.conditionalActions[element]) {
                                // console.log('this.props.page?.conditionalActions[element]', this.props.page?.conditionalActions[element])
                                // console.log('elementent]', element)
                                // console.log('actions', actions)
                                actions[element] = this.props.page?.conditionalActions[element]
                            }
                            // console.log('firstelement', element)
                            if (this.props.page.headerObject && this.props.page.headerObject[element]) {
                                headers = [...headers, ...this.props.page.headerObject[element]]
                                // console.log('headers', headers)
                            }
                        })
                    }

                    // console.log('mystate', this.state.headers)
                    // console.log('this.state.headers', this.props.page?.headers)
                    let stepId
                    if (fetchResult.info.status && fetchResult.info.status[fetchResult.info.activeWorkflow]) {
                        stepId = fetchResult.info.status[fetchResult.info.activeWorkflow]?.id
                    }
                    console.log('this.state.docPermissionp[', fetchResult.info)
                    if (Array.isArray(this.state.docPermission) && this.state.docPermission.includes('mandatory') && (!fetchResult.info?.values || !fetchResult.info?.values[stepId]?.consultationData?.approve)) {
                        headers.map((element) => {
                            if (element.key == 'consultation') {
                                element.information.required = true
                            } else {
                                element.information.required = false

                            }
                        })
                    }
                    headers = [...headers, ...(this.state.headers ?? [])]
                    // if (fetchResult.info.documentStatus == 'pending') {
                    //     headers = this.props.page.headerObject['pending']
                    // }
                    // this.setState({ isLoader: false })
                    this.setState({ headers, actions })
                })
            }


        })
        // this.setState({ headers: this.props.headers, activePage: null })
    }
    checkSections = (checkSections) => {
        if (checkSections) {
            let newSection = []
            let sections = this.state.sections
            sections.map((element) => {
                // console.log('element section', element)
                if (element.key != 'actioninfononcompliance' && element.key != 'noncompliance') {
                    if (checkSections[element.key]) {
                        newSection.push(element)
                    }

                }
                else {
                    newSection.push(element)
                }
            })
            this.setState({ sections: newSection })
        }
    }
    groupBy = (recordResult) => {
        console.log('recordResult5', recordResult)
        let grouped = {}
        recordResult.map((element) => {
            // console.log('elemet33', element)
            if (!grouped[element.planningId]) {
                grouped[element.planningId] = { key: element.planningId, title: element.descriptionAction, list: [] }
            }
            grouped[element.planningId].list.push(element)

        })
        console.log('groupedRecordResult5', grouped)
        this.setState({ groupedRecordResult: grouped })

    }

    submitForm = (key, forcePost) => {
        if (this.props.submitForm) {
            let data = this.form.getForm()
            if (data) {
                this.props.submitForm({ ...data })
            }
        } else {
            this.postValue(key, forcePost)
        }
    }
    editCreateDocument = (key, value, info) => {
        let body = this.form.getForm() ?? {}
        console.log('body isiss', body)
        console.log('this.state.data', this.state.data)
        body._id = this.state.data._id
        body.activeWorkflow = info
        console.log('fibodyrst', body)
        HttpServices.request('editCreateDocument', body, (fetchResult, fetchError) => {
            console.log('hsoidhfsidfid', fetchError)
            if (fetchError) {
                console.log('fetchError', fetchError)
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.postDataFailed'), description: checkTranslation(fetchError.message) })
                return
            }

            console.log('daraisiss', this.state.data)
            console.log('fetchResultsl', fetchResult)
            if (fetchResult.closeStage) {
                this.props.history.goBack()
            }
        })
    }

    filDescription = (state, key, event) => {
        let stateObject = this.state[state]
        stateObject[key] = event.target.value
        // console.log('stateObject', stateObject)
        this.setState({ [state]: stateObject })
    }

    handleCheckbox = (key) => {
        let effectivenessData = this.state.effectivenessData
        if (!effectivenessData.reason) {
            effectivenessData.reason = {}
        }
        if (!effectivenessData.reason[key]) {
            effectivenessData.reason[key] = false
        }
        effectivenessData.reason[key] = !effectivenessData.reason[key]
        // console.log('effectivenessData.reason', effectivenessData.reason)
        this.setState({ effectivenessData })
    }


    postValue = (key, forcePost) => {
        // console.log("postValue", this.state.id)
        // console.log("page", this.props.page)
        if (this.form) {
            // console.log('s', this.form)
            let data = this.form.getForm()
            this.setState({ errors: null })
            let page = this.props.page

            console.log('potvalue', data)
            if (data || forcePost) {
                let isEditing = data._id ? true : false
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                data.page = this.props.page?.page ? this.props.page?.page : this.props.page?.key
                this.setState({ isPostingData: true })

                if (page.postBody) {
                    data = { ...data, ...page.postBody }
                }

                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {

                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }

                let search = window.location.search;
                let params = new URLSearchParams(search);
                let plannedId = params.get('plannedId')

                if (plannedId) {
                    data.plannedId = plannedId
                }
                data.key = key
                data.id = this.state.id
                if (!data.id) {
                    data.id = params.get('id')
                }

                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.postDataFailed'), description: checkTranslation(fetchError.message) })
                        return
                    }
                    // this.modal.hideModal()
                    this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}Sent Succesfully'), description: checkTranslation('{{lang}}Send Record Succesfully') })
                    if ((!Array.isArray(this.state.reports) && !Array.isArray(this.state.planningList) && !Array.isArray(this.state.submitedResultList)) || fetchResult.close) {
                        this.cancelClicked()
                    } else {

                        // this.init()
                        if (fetchResult.info?.planning) {
                            this.setState({ planning: fetchResult.info?.planning })
                        }
                        if (fetchResult.info?.submitedResult) {
                            this.setState({ submitedResultList: fetchResult.info?.submitedResult })
                        }
                        console.log('ttttttt', fetchResult)
                    }
                    // if (!isEditing && this.props.itemAdded) {
                    //     this.props.itemAdded(fetchResult.info, this.props.modalIndex)
                    // }

                    // if (isEditing && this.props.itemEdited) {

                    //     if (fetchResult.info) {
                    //         this.props.itemEdited(fetchResult.info, data._id, this.props.modalIndex)
                    //     } else {
                    //         this.props.itemEdited(data, data._id, this.props.modalIndex)
                    //     }
                    // }
                })
            }
        }
    }

    review = () => {
        this.setState({ errors: null })
        let page = this.props.page
        // let address = page.reviewUrl
        this.setState({ isPostingData: true })
        let data = {}
        data.id = this.state.id
        if (!data.id) {
            let search = window.location.search;
            console.log('searchis ', search)
            let params = new URLSearchParams(search);
            data.id = params.get('id');
        }
        data.stage = page.reviewStage
        // console.log('addddddddd', address)
        console.log('data is', data)
        HttpServices.request('reviewNonCompliance', data, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isPostingData: false })
            if (fetchError) {
                this.setState({ errors: fetchError.errors })
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.postDataFailed'), description: checkTranslation(fetchError.message) })
                return
            }
            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}Sent Succesfully'), description: checkTranslation('{{lang}}The review was recorded by the assessor') })
            this.cancelClicked()
        })
    }




    cancelClicked = () => {
        console.log('333')
        // let search = this.props.location.search;
        // let params = new URLSearchParams(search);
        // let ref = params.get('ref');
        // if (ref && ref !== '') {
        //     // console.log(ref)
        //     this.props.history.push(ref)
        // } else {
        this.props.history.goBack()
        // }

    }

    changePage = (index, prop) => {
        this.setState({ activePage: index, hideModal: true }, () => {
            if (index == null) {
                this.setState({ hideModal: false, headers: this.props.headers })
            } else {
                this.setState({ hideModal: false, headers: this.props.page?.pages[index].headers })

            }
        })
    }
    approveConsultation = (key, value, info) => {
        let data = this.state.data ?? {}
        let body = {}
        body.values = this.form.getForm() ?? {}
        body._id = data._id
        body.values.approve = info
        console.log('mybodiy is ', body)
        console.log('myinfo is ', info)
        console.log('data is ', data)
        HttpServices.request('approveConsultation', body, (fetchResult, fetchError) => {
            console.log('fetchErroris', fetchError)
            console.log('fetchResultis', fetchResult)
            if (fetchError) {
                return
            }
            if (fetchResult.closeStage) {
                this.props.history.goBack()
            }
            this.setState({ data: fetchResult.info })

        })
    }
    postCreateDocument = (data) => {
        let body = data == 'formCorrection' ? this.formCorrection.getForm() ?? {} : this.form.getForm() ?? {}
        console.log('booooooody', body)
        HttpServices.request('postCreateDocument', body, (fetchResult, fetchError) => {
            if (fetchError) {
                store.dispatch(actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.postDataFailed'), description: checkTranslation(fetchError.message) }))
                return
            }
            this.props.history.goBack()
        })
    }
    finishDocument = () => {
        console.log('data _ID', this.state.data._id)
        let body = {}
        body._id = this.state.data._id
        HttpServices.request('finishDocument', body, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log('fetchError', fetchError)
                store.dispatch(actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errrs.PostDataDoneFaild'), description: checkTranslation(fetchError.message) }))
                return
            }
            console.log('fetchResult', fetchResult)
            this.props.history.goBack()
        })
    }
    reviewDocument = () => {

        let steps = []
        let data = this.state.data
        let activeFlow = ''
        switch (data.activeWorkflow) {
            case 'create':
                activeFlow = 'workflowCreate'
                break;

            case 'edit':
                activeFlow = 'workflowEdit'
                break;

            case 'remove':
                activeFlow = 'workflowRemove'

                break;

            default:
                break;
        }
        console.log('data.status[data.activeWorkflow].id', data.status[data.activeWorkflow].id)
        console.log('data.documentGroup[activeFlow].step', data.documentGroup[activeFlow].step)
        let pass = true
        for (let i = 0; i < data.documentGroup[activeFlow].step.length; i++) {
            if (data.documentGroup[activeFlow].step[i].id == data.status[data.activeWorkflow].id) {

                pass = false
            }
            if (pass) {

                steps.push(data.documentGroup[activeFlow].step[i])
            }

        }
        // data.documentGroup[activeFlow].step.map((prop) => {
        // })
        this.setState({ steps }, () => {

            this.showReviewModal.showModal()
        })
        // let body = {}
        // body.review = ''
        // HttpServices.request('', body, (fetchResult, fetchError) => {
        //     if (fetchError) {
        //         console.log('fetchError', fetchError)
        //         store.dispatch(actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}err'), description: checkTranslation(fetchError.message) }))
        //         return
        //     }
        //     console.log(fetchResult)
        //     this.props.history.goBack()
        // })

    }
    postReviewDocument = () => {

    }
    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups
        closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
        this.setState({ closedGroups })
    }

    itemAdded = () => { }

    itemEdited = (editedItem, id, modalIndex) => {
        console.log('itemEdited')
        console.log('editedItem', editedItem)
        console.log('modalIndex', modalIndex)
        let planning = this.state.planning
        let submitedResultList = this.state.submitedResultList
        let key
        if (planning && planning.length != 0) {
            key = planning
        }
        else if (submitedResultList && submitedResultList.length != 0) {
            key = submitedResultList
        }
        console.log('key is', key)
        key.forEach((element, index) => {
            let id = element.id ?? element._id
            if (!Array.isArray(editedItem)) {
                editedItem = [editedItem]
            }
            editedItem.map((item, cIndex) => {
                if (item._id == id) {
                    key[index] = item
                }
            })
        })
        console.log('val is', [key])

        this.setState({ [key]: [key] })
        return

    }
    activeWorkflow
    translateStatus = (stage) => {
        let translatedStage
        switch (stage) {
            case 'pending':
                translatedStage = '{{lang}}Pending'
                break;

            case 'approve':
                translatedStage = '{{lang}}Approve'
                break;

            case 'reject':
                translatedStage = '{{lang}}Reject'
                break;

            case 'needEdit':
                translatedStage = '{{lang}}Need Edit'
                break;

            case 'consultation':
                translatedStage = '{{lang}}Consultation'
                break;

            case 'done':
                translatedStage = '{{lang}}Published'
                break;
            case 'deprecate':
                translatedStage = '{{lang}}Deprecate'
                break;

            default:
                translatedStage = stage
                break;
        }
        return translatedStage
    }
    translateStage = (stage) => {
        let translatedStage
        switch (stage) {
            case 'create':
                translatedStage = '{{lang}}Create'
                break;

            case 'edit':
                translatedStage = '{{lang}}Edit'
                break;

            case 'remove':
                translatedStage = '{{lang}}Remove'
                break;

            default:
                translatedStage = stage
                break;
        }
        return translatedStage
    }

    postDocumentStatus = () => {
        console.log('return', this.state.data)

        let data = this.state.data ?? {}
        let body = this.form.getForm() ?? {}
        body._id = data._id
        body.workflow = data.documentGroup.workflowCreate._id
        body.active = data.activeWorkflow
        // body.values = {}
        // body.values.pending = this.form.getForm()
        HttpServices.request('approveDocument', body, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log('fetchError', fetchError)
                return
            }
            if (fetchResult.closeStage) {
                this.props.history.goBack()
            }
            console.log('fetchResult.info', fetchResult.info)
            this.setState({ data: fetchResult.info })
        })

    }
    changeTab = (index) => {
        this.setState({ currentTab: index })
    }
    nextWorkflowStep = () => {
        let data = this.state.data ?? {}
        let values = this.form.getForm()
        if (values) {

            console.log('valuessss ', values)
            console.log('datasss ', data)
            let body = {}
            body._id = data._id
            body.workflow = data.documentGroup.workflowCreate._id
            body.active = data.activeWorkflow
            body.values = {}
            body.values = this.form.getForm()
            console.log('bodyyyyyyyyyyyyyyy', body)
            HttpServices.request('nextWorkflowStep', body, (fetchResult, fetchError) => {
                if (fetchError) {
                    console.log('fetchError', fetchError)
                    return
                }
                if (fetchResult.closeStage) {
                    this.props.history.goBack()
                }
                console.log('fetchResult.info', fetchResult.info)
                this.setState({ data: fetchResult.info })
            })
        }

    }
    showHistories = () => {
        return this.state.history.map((item, index) => {
            switch (item.action) {
                case 'create':
                    return (
                        <div className="flexc">
                            <ul>
                                <li className="mrd-3" style={{ color: "#222" }}> مدرک {item.extra.createDocumentModel.name} ساخته شد</li>
                            </ul>
                            <p style={{ color: 'gray', fontSize: 14 }}>{moment(item.date).format('YYYY-MM-DD HH:mm')}</p>
                            {/* <p>{item.des}</p> */}
                        </div>
                    )
                    break;
                case "approveDoc":
                    return (
                        <div className=" flexc">

                            {item.newData.documentStatus == 'approve' ? (
                                <ul>
                                    <li className="mrd-3" style={{ color: "#222" }}>مدرک {item.extra.createDocumentModel.name} تایید شد</li>
                                </ul>
                            ) : (<></>)}

                            {item.newData.documentStatus == 'reject' ? (
                                <ul>
                                    <li className="mrd-3" style={{ color: "#222" }}>مدرک {item.extra.createDocumentModel.name} رد شد</li>
                                </ul>
                            ) : (<></>)}
                            {item.newData.documentStatus == 'needEdit' ? (
                                <ul>
                                    <li className="mrd-3" style={{ color: "#222" }}>مدرک {item.extra.createDocumentModel.name} احتیاج به اصلاح دارد</li>
                                </ul>
                            ) : (<></>)}
                            <p style={{ color: 'gray', fontSize: 14 }}>{moment(item.date).format('YYYY-MM-DD HH:mm')}</p>
                            {/* <p>{item.des}</p> */}
                        </div>
                    )
                    break;
                case "updateFlow":
                    //     {console.log('item.newData.values[item.stepId]', item.newData.values[item.stepId])}
                    // <p style={{ color: 'gray', fontSize: 14 }}>{moment(item.date).format('YYYY-MM-DD HH:mm')}</p>
                    return (
                        <div className="">
                            {/* {item.newData.values[item.stepId] ? ( */}
                            <>
                                {item&& item.newData && Object.entries(item.newData.values[item.stepId]).map(([key, value]) => {
                                    // console.log('keeeeeeeeeeey', key)
                                    // console.log('vallllllue', value)
                                    if (key == 'description') {
                                        return (
                                            <div className="w-100 p-2 my-2" style={{ border: '1px solid rgba(0,0,0,0.1)', borderRadius: '10px' }}>
                                                <div className="flexc">
                                                    <ul>
                                                        <li className="mrd-3" style={{ color: "#222" }}>به مدرک {item.extra.createDocumentModel.name} توضیحات اضافه شد</li>
                                                    </ul>
                                                    <p style={{ color: 'gray', fontSize: 14 }}>{moment(item.date).format('YYYY-MM-DD HH:mm')}</p>
                                                </div>
                                                <div className="p-3 mx-auto container" style={{ background: '#fff', borderRadius: '10px' }}>
                                                    <p style={{ color: '#808080' }}>{value}</p>
                                                </div>
                                            </div>
                                        )
                                    } else if (key == 'consultation') {
                                        return (
                                            <div className="w-100 p-2 my-2" style={{ border: '1px solid rgba(0,0,0,0.1)', borderRadius: '10px' }}>
                                                <div className="flexc">
                                                    <ul>
                                                        <li className="mrd-3" style={{ color: "#222" }}>مدرک {item.extra.createDocumentModel.name} جهت مشورت ارجاع داده شد</li>
                                                    </ul>
                                                    <p style={{ color: 'gray', fontSize: 14 }}>{moment(item.date).format('YYYY-MM-DD HH:mm')}</p>
                                                </div>
                                            </div>
                                        )
                                    } else if (key == 'attachment') {
                                        return (
                                            <div className="w-100 p-2 my-2" style={{ border: '1px solid rgba(0,0,0,0.1)', borderRadius: '10px' }}>
                                                <div className="flexc">
                                                    <ul>
                                                        <li className="mrd-3" style={{ color: "#222" }}>به مدرک {item.extra.createDocumentModel.name} فایل اضافه شد</li>
                                                    </ul>
                                                    <p style={{ color: 'gray', fontSize: 14 }}>{moment(item.date).format('YYYY-MM-DD HH:mm')}</p>
                                                </div>
                                                <div className="p-3 mx-auto container" style={{ background: '#fff', borderRadius: '10px' }}>
                                                    <p style={{ color: '#808080' }}>{value}</p>
                                                </div>
                                            </div>
                                        )
                                    }
                                })}
                            </>
                            {/* ) : <></>} */}
                        </div>
                    )
                    break;

                default:
                    break;
            }

        })
    }

    render() {
        return (
            <div className="container" style={{ minHeight: '100vh' }}>
                {!this.state.isLoader ? (
                    <div className="py-2" style={{ margin: '0 auto' }}>


                        <div className="mt-3" style={{}}>
                            {console.log('this.state.data-0--0', this.state.data)}

                            {this.props.page?.tabBar?.map((item, index) => {

                                if (item.key != 'correction') {
                                    return (
                                        <button className="pb-1 mb-3 " style={{ borderBottom: item.key == this.state.currentTab ? '2px solid #184d94' : '2px solid transparent' }} onClick={() => this.changeTab(item.key)}>
                                            <p className="px-2" style={{ fontSize: 16 }}>{checkTranslation(item.title)}</p>
                                        </button>
                                    )

                                } else if (this.state.data && this.state.data.documentStatus == 'needEdit') {

                                    return (
                                        <button className="pb-1 mb-3 " style={{ borderBottom: item.key == this.state.currentTab ? '2px solid #184d94' : '2px solid transparent' }} onClick={() => this.changeTab(item.key)}>
                                            <p className="px-2" style={{ fontSize: 16 }}>{checkTranslation(item.title)}</p>
                                        </button>
                                    )
                                }
                            })
                            }
                            {/* {this.state.currentTab == 'document' && (
                                <>
                                    {Array.isArray(this.state.sections) && this.state.data && this.state.sections?.map((prop, index) => {
                                        let data = this.state.data
                                     
                                        return (

                                            <div className="my-3" style={{ background: '#f6f6f6', borderRadius: 15 }} key={index}>
                                                <div className="flexcb cursor-pointer" onClick={() => this.changeCollapse(prop.key)} style={{ backgroundColor: '#2367c2', borderBottom: '1px solid #fff', borderRadius: this.state.collapses[prop.key] ? '15px' : '15px 15px 0 0', padding: '12px 22px' }}>
                                                    <div className="flexcc">
                                                        <p className="" style={{ color: '#fff', }}>{checkTranslation(prop.title)}</p>
                                                        {prop.level ? (
                                                            <p className="px-3" style={{ color: '#fff' }}>مرحله {this.state.stepLevel} از {this.state.level}</p>
                                                        ) : <></>}
                                                    </div>

                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" class="" style={{ width: 18, transform: this.state.collapses[prop.key] ? 'rotate(-90deg)' : (i18n.language == 'fa' ? '' : 'rotate(180deg)'), transition: "all 0.3" }}>
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                                    </svg>

                                                </div>
                                                <Collapsible open={!this.state.collapses[prop.key]} transitionTime={500}>
                                                    <div className="py-0 py-md-2 px-0 px-md-2">
                                                        <div className="row m-0" >
                                                          
                                                            {prop.headers.map((header, j) => {
                                                                let value = getObject(data, header.key)
                                                                let Component = tableComponents[header.type]
                                                                if (value) {

                                                                    return (
                                                                        <>
                                                                            <div key={j} className={'py-2 col-12 col-lg-' + header.col}>
                                                                                <div className="d-flex ">
                                                                                    <p style={{ whiteSpace: 'nowrap', fontSize: 15 }}>{checkTranslation(header.information?.label)} :&nbsp;</p>
                                                                                    {Component && (
                                                                                        <Component data={value} onTable={true} header={header} />
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                        </>
                                                                    )
                                                                }
                                                            })}
                                                        </div>
                                                    </div>
                                                </Collapsible>
                                            </div>
                                        )
                                    })}
                                </>
                            )} */}
                            {this.state.currentTab == 'history' && (
                                <div>
                                    <div style={{ backgroundColor: '#2367c2', borderBottom: '1px solid #fff', borderRadius: '15px 15px 0 0', padding: '12px 22px' }}>
                                        <p className="" style={{ color: '#fff', }}>{checkTranslation('{{lang}}Document history')}</p>
                                    </div>
                                    <div style={{ background: "#F6F6F6", borderRadius: '0 0 15px 15px', padding: '12px 22px' }}>
                                        {console.log('popopopo', this.state.history)}
                                        {this.showHistories()}

                                    </div>
                                </div>
                            )}
                            {this.state.currentTab == 'correction' && (
                                <div>
                                    <div class="w-100 flexcc" style={{ zIndex: 1, padding: '12px 22px', position: 'sticky', top: 0, borderBottom: '0px solid rgb(238, 238, 238)', background: ' rgb(35, 103, 193)', borderRadius: "15px 15px 0px 0px" }}><span style={{ color: 'rgb(255, 255, 255)' }}>{translate('درخواست ایجاد مدرک')}</span></div>
                                    <div className="py-3 px-4 mb-3" style={{ background: "#F6F6F6", borderRadius: "0px 0px 15px 15px" }}>
                                        <FormViewer ref={el => this.formCorrection = el} headers={this.state.correction} isEditing={this.props?.initData?._id ? true : false} initData={this.state.data} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} openRefModal={this.props.openRefModal} functionsHandler={this.props.functionsHandler} />
                                        <div className="flexc flex-wrap px-3 pb-3 mt-4" >




                                        </div>
                                    </div>
                                    <LoaderButton
                                        onClick={() => this.postCreateDocument('formCorrection')}
                                        text={translate('post')}
                                        type={"Oval"}
                                        className="text-bold text-small  w-100"
                                        buttonStyle={{ outline: 'none', background: '#184d94', cursor: 'pointer', padding: '8px 20px 8px 20px', borderRadius: 50, textTransform: 'uppercase', fontSize: 15, color: '#fff', border: 'none' }}
                                        width={40}
                                        height={40}

                                    />
                                </div>
                            )}
                        </div>


                        {this.state.currentTab == 'document' && (
                            <>
                                {/* {console.log('this.state.sectionssssss',this.state.data)} */}
                                {Array.isArray(this.state.sections) && this.state.data && this.state.sections?.map((prop, index) => {
                                    let data = this.state.data
                                    // {console.log('tpppepep')}
                                    // if (prop.key == 'infoplanning') {
                                    //     data = this.state.planning[0]
                                    // }
                                    // console.log('dataONSectioN', this.state.data)
                                    // console.log('dataONSectioN', data)
                                    return (

                                        <div className="my-3" style={{ background: '#f6f6f6', borderRadius: 15 }} key={index}>
                                            <div className="flexcb cursor-pointer" onClick={() => this.changeCollapse(prop.key)} style={{ backgroundColor: '#2367c2', borderBottom: '1px solid #fff', borderRadius: this.state.collapses[prop.key] ? '15px' : '15px 15px 0 0', padding: '12px 22px' }}>
                                                <div className="flexcc">
                                                    <p className="" style={{ color: '#fff', }}>{checkTranslation(prop.title)}</p>
                                                    {prop.level ? (
                                                        <p className="px-3" style={{ color: '#fff' }}>مرحله {this.state.stepLevel} از {this.state.level}</p>
                                                    ) : <></>}
                                                </div>
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" class="" style={{ width: 18, transform: this.state.collapses[prop.key] ? 'rotate(-90deg)' : (i18n.language == 'fa' ? '' : 'rotate(180deg)'), transition: "all 0.3" }}>
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                                </svg>

                                            </div>
                                            <Collapsible open={!this.state.collapses[prop.key]} transitionTime={500}>
                                                <div className="py-2 px-2">
                                                    <div className="row m-0" >
                                                        {/* {console.log('header ',prop.headers )} */}
                                                        {/* {console.log('header data',data )} */}
                                                        {prop.headers.map((header, j) => {
                                                            // console.log('data, header.key',data, header)
                                                            let value = getObject(data, header.key)
                                                            let Component = tableComponents[header.type]
                                                            if (header.key == 'documentStatus') {
                                                                value = this.translateStatus(value)
                                                            }
                                                            if (header.key == 'activeWorkflow') {
                                                                value = this.translateStage(value)
                                                            }

                                                            if (value) {

                                                                return (
                                                                    <>
                                                                        <div key={j} className={'py-2 col-12 col-lg-' + header.col}>
                                                                            <div className="d-flex ">
                                                                                <p style={{ whiteSpace: 'nowrap', fontSize: 15 }}>{checkTranslation(header.information?.label)} :&nbsp;</p>
                                                                                {Component && (
                                                                                    <Component data={value} onTable={true} header={header} />
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                    </>
                                                                )
                                                            }
                                                        })}
                                                    </div>
                                                    {/* <FormViewer ref={el => this.form = el} headers={prop.headers} isEditing={this.props?.initData?._id ? true : false} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} openRefModal={this.props.openRefModal} functionsHandler={this.props.functionsHandler} /> */}
                                                </div>
                                            </Collapsible>
                                        </div>
                                    )
                                })}
                                {console.log('adminsections', this.props.page)}
                                <div className="pb-5 h-100 mt-3 mt-md-3">


                                    <p className="text-small mb-2  px-2" style={{ color: '#00000050' }}>{this.props.initData?._id}</p>
                                    {(!this.props.page?.hideComponent) && (

                                        <div className="w-100 h-100 mb-3" style={{ overflow: 'auto', borderRadius: 15 }}>
                                            {console.log('this.state.datais', this.state.data)}
                                            {(!this.props.page?.hideSection || (this.props.page?.hideSection && (!this.state.data || Object.values(this.state.data).length == 0))) && (
                                                <div style={{ backgroundColor: '#f6f6f6', borderRadius: '15px' }}>
                                                    <div className="w-100 flexcc" style={{ zIndex: 1, padding: '12px 22px', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#2367c1', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '15px 15px 0px 0px' }}>
                                                        <span style={{ color: "#fff" }}>{checkTranslation(this.props.page?.title)}</span>
                                                    </div>

                                                    {this.props.page?.pages && (
                                                        <div className="w-100 flexc mb-2">

                                                            <div className="ml-0 text-center" onClick={() => { this.changePage(null) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', transition: 'all 0.5s', backgroundColor: this.state.activePage == null ? '#F87C56' : '#F87C56b7f', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                                                <p>{translate('Details')}</p>
                                                            </div>

                                                            {this.props.page.pages.map((prop, index) => {
                                                                return (
                                                                    <div className="ml-0 text-center" onClick={() => { this.changePage(index, prop) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', borderLeft: '1px solid #89a', transition: 'all 0.3s', backgroundColor: this.state.activePage == index ? (prop.tabColor ?? '#F87C56') : '#F87C56b7f', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                                                        <p>{checkTranslation(prop.title)}</p>
                                                                    </div>)
                                                            })}

                                                        </div>
                                                    )}
                                                    {!this.props.page?.hideForm && (
                                                        <div className="py-3 px-4">

                                                            <FormViewer ref={el => this.form = el} headers={this.state.headers ?? (this.state.headerObject ? this.state.headerObject[this.state.data?.documentStatus] : [])} isEditing={this.props?.initData?._id ? true : false} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} openRefModal={this.props.openRefModal} functionsHandler={this.props.functionsHandler} />
                                                        </div>
                                                    )}

                                                </div>
                                            )}
                                            {console.log('this.state.actionscccs', (!this.props.page?.hideActions))}
                                            {(this.state.actions && (!this.props.page?.hideActions || (this.props.page?.hideActions && !this.state.data))) && (

                                                <div className="flexc flex-wrap px-3 pb-3 mt-4" >
                                                    {Object.values(this.state.actions)?.map((prop, index) => {
                                                        // console.log('ttttttttttttttttttt',this.props.variables?.permissionRoot)
                                                        // console.log('propproppropsssss', prop)
                                                        if (prop.key != 'submit' || (!this.props.initData?._id && (checkPermission(this.props.variables?.permissionRoot + '.create'))) || (this.props.initData?._id && (checkPermission(this.props.variables?.permissionRoot + '.edit'))))
                                                            return (
                                                                <div key={index} className=" mx-1">
                                                                    <LoaderButton
                                                                        onClick={() => this[prop.function](prop.key, prop.forcePost, prop.info)}
                                                                        isLoading={this.props[prop.loader] ?? this.state[prop.loader]}
                                                                        text={checkTranslation(prop.label)}
                                                                        type={"Oval"}
                                                                        className="text-bold text-small  w-100"
                                                                        buttonStyle={{ outline: 'none', background: prop.bgColor ? prop.bgColor : '#184d94', cursor: 'pointer', padding: '8px 20px 8px 20px', borderRadius: 50, textTransform: 'uppercase', fontSize: 15, color: prop.color ? prop.color : '#fff', border: 'none' }}
                                                                        width={40}
                                                                        height={40}
                                                                        color={prop.bgColor}
                                                                    />
                                                                </div>
                                                            )
                                                    })}
                                                </div>
                                            )}


                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                ) : (
                    <div className="flexcc w-100 h-100 pt-5">
                        <div className="p-2 text-center my-5">
                            <Loader
                                type="Oval"
                                color="#184d94"
                                height="40"
                                width="40"
                            />
                        </div>
                    </div>
                )
                }
                <ItemModal
                    ref={el => this.editModal = el}
                    page={this.props.page}
                    initData={this.state.plannedList}
                    variables={this.props.variables}
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    openRefModal={this.openRefModal}
                    functionsHandler={this.functionsHandler}
                    showDates={true}
                    // modalIndex={index}
                    bgColor={'red'}
                    headers={this.state.headers}
                />
                <Modal ref={el => this.showReviewModal = el} maxWidth={600}>
                    {this.state.steps && this.state.steps?.map((element) => {

                        return (

                            <div>
                                <p>
                                    {element.inCharge.name}
                                </p>
                                {console.log('showwwww', this.state.data)}
                            </div>
                        )
                    })}
                </Modal>
            </div >
        );

    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(AdminSectionFormApplet);
